import {StatusService} from '../../../shared/services/authentication/status.service';
import {FormsService} from '../../../shared/services/form/forms.service';
import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AnalyticsService} from '../../../shared/services/analytics/analytics.service';
import {EventEnum, PathUrlEnum} from '../../../utils/analytics.utils';
import {IProposal} from '../../../shared/interfaces/IProposal';
import {Step} from '../../../shared/models/step';
import {SellerPJDataPayload} from "../../../shared/models/sellerPj.model";
import {RouteUtils} from "../../../utils/route.utils";
import {formatToIsoDate} from "../../../utils/date.utils";

@Component({
  selector: 'app-seller-shell-pj',
  templateUrl: './seller-shell-pj.component.html',
  styleUrls: ['./seller-shell-pj.component.scss'],
})
export class SellerShellPjComponent implements OnInit {
  @Input() account: Number[];
  proposal: IProposal;
  step: Step;
  totalSteps = 4;
  currentStep = 1;
  buttonDisable = true;
  percent = (100 / this.totalSteps) * this.currentStep;
  dataCompany = new SellerPJDataPayload();
  showError = false;
  errorMessage = '';
  showModalExit = false;
  loadingSaveForm = false;

  constructor(
    private _router: Router,
    private formsService: FormsService,
    private statusService: StatusService,
    private analyticsService: AnalyticsService,
  ) {
  }

  ngOnInit(): void {
    this.getCompany();
  }

  private getCompany() {
    const participantValues = this.formsService.getNameAndDocument();
    if (!participantValues?.documentNumber) {
      this.showError = true;
      this.errorMessage = 'Não foi possível carregar as informações de razão social e CNPJ';
      return;
    }
    this.dataCompany.corporateName = participantValues.name;
    this.dataCompany.documentNumber = participantValues.documentNumber;
  }

  private getCurrentCustomPath(): PathUrlEnum {
    switch (this.currentStep) {
      case 1:
        return PathUrlEnum.PROPRIETARIO_PJ_DADOS_EMPRESA;
      case 2:
        return PathUrlEnum.PROPRIETARIO_PJ_DADOS_REPRESENTANTES;
      case 3:
        return PathUrlEnum.PROPRIETARIO_PJ_DADOS_PAGAMENTO;
      case 4:
        return PathUrlEnum.PROPRIETARIO_PJ_SALVAR_FORM;
      default:
        return PathUrlEnum.PROPRIETARIO_PJ_DADOS_EMPRESA;
    }
  }

  backStep() {
    this.analyticsService.trackEvent(this.getCurrentCustomPath(), EventEnum.BTN_VOLTAR);
    if (this.currentStep <= 1) {
      this.showModalExit = true;
    } else {
      this.focusFirstElement();
      this.currentStep--;
      this.percent = (100 / this.totalSteps) * this.currentStep;
    }
  }

  navigateFormList(): void {
    this._router.navigateByUrl(RouteUtils.PAGES.FORM_LIST);
  }

  focusFirstElement() {
    document.getElementById('backButton')?.focus();
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }

  goToNextStep() {
    this.analyticsService.trackEvent(this.getCurrentCustomPath(), EventEnum.BTN_CONTINUAR);
    this.focusFirstElement();
    if (this.currentStep < this.totalSteps) {
      this.currentStep++;
      this.buttonDisable = true;
      this.percent = (100 / this.totalSteps) * this.currentStep;
    }
  }

  private formatSellerShellData(data: SellerPJDataPayload): SellerPJDataPayload {
    const clone: SellerPJDataPayload = JSON.parse(JSON.stringify(data));
    clone.corporateName = clone.corporateName?.trim();
    clone.lastChangeDate = formatToIsoDate(clone.lastChangeDate);

    if (clone.representatives?.length) {
      clone.representatives.forEach(rep => {
        if (rep.name) {
          rep.name = rep.name.trim();
        }
      });
    }

    if (clone.attorneys?.length) {
      clone.attorneys.forEach(att => {
        if (att.name) {
          att.name = att.name.trim();
        }
      });
    }
    clone.bankAccounts.forEach(bank => {
      bank.accountDigit = bank.accountNumber.replace(/-/g, '').slice(-1);
      bank.accountNumber = bank.accountNumber.replace(/-/g, '').slice(0, -1);
    });

    return clone;
  }

  submitFormsPj() {
    this.analyticsService.trackEvent(PathUrlEnum.PROPRIETARIO_PJ_SALVAR_FORM, EventEnum.BTN_SALVAR_FORMULARIO);
    this.loadingSaveForm = true;
    this.formsService
      .postFormSellerPj(this.formatSellerShellData(this.dataCompany))
      .subscribe({
        error: err => {
          this.loadingSaveForm = false;
          this.showError = true;
          this.errorMessage = err.error.errors
            ? err.error.errors[0].message
            : 'Não foi possível processar o checklist';
        },
        complete: () => {
          this.loadingSaveForm = false;
          this.statusService.showToast('success', 'formulário de dados da empresa salvo');
          this._router.navigateByUrl(RouteUtils.PAGES.FORM_LIST);
        },
      });
  }

  receiverDataForms(data: SellerPJDataPayload) {
    this.dataCompany = data;
  }

  reciverFormsComplete(reciverForms: boolean) {
    this.buttonDisable = !reciverForms;
  }

  reciverTryAgain() {
    this.showError = false;
  }
}
